function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Calque 2"
}, React.createElement("path", {
  d: "M10.62 27.44c12.75 0 19.72-10.55 19.72-19.71v-.9a13.9 13.9 0 0 0 3.46-3.59 13.87 13.87 0 0 1-4 1.1 7 7 0 0 0 3-3.84 13.69 13.69 0 0 1-4.4 1.68A6.94 6.94 0 0 0 16.63 8.5 19.64 19.64 0 0 1 2.35 1.26a6.93 6.93 0 0 0 2.15 9.25 6.91 6.91 0 0 1-3.15-.86v.09a6.94 6.94 0 0 0 5.56 6.79 6.9 6.9 0 0 1-3.13.12 7 7 0 0 0 6.48 4.81 13.88 13.88 0 0 1-8.61 3A13 13 0 0 1 0 24.33a19.62 19.62 0 0 0 10.62 3.11",
  fill: "#1b1c92",
  "data-name": "Logo FIXED"
}));

var SvgIcoTwitter = function SvgIcoTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 33.78 27.44",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_twitter.10294417.svg";
export { ForwardRef as ReactComponent };